<template>
  <div class="modal spot-detail-wrap">
    <div class="spot-outer">
      <div class="spot-inner">
        <div class="close-modal-btn" @click="closeModal()">閉じる</div>
        <div class="detail-image-wrap">
          <a class="prev-button" @click="prev" href="javascript:void(0)"></a>
          <slick ref="slick"
          :options="slickOptions">
            <!-- 実際は取得分をループする -->
            <div v-for="(img, index) in images" v-bind:key="index">
              <img :src="img.image_url" class="detail-image">
              <p class="supplement">{{ img.comment || '' }}</p>
            </div>
          </slick>
          <a class="next-button" @click="next" href="javascript:void(0)"></a>
          <span class="spot">SPOT:</span>
          <span class="spot-name-on">{{ $store.getters['detail/getName'] }}</span>
        </div>
        <div class="detail-head-wrap">
          <p class="spot-name" v-show="!editing">{{ $store.getters['detail/getName'] }}</p>
          <!-- 編集クリックで以下に切り替わる -->
          <textarea class="spot-name text" v-model="name" v-show="editing"></textarea>
          <div class="head-btn-wrap">
            <a href="javascript:void(0)" class="share" @click="showSns = !showSns">シェア</a>
            <a href="javascript:void(0)" class="favorite" v-bind:class="{on: favorite}" @click="addToFavorite">お気に入り</a>
            <!--<a href="javascript:void(0)" class="favorite-fill">お気に入り</a>-->
            <div class="share-sns-wrap" v-show="showSns">
              <a href="javascript:void(0)" class="close-sns-wrap" @click="showSns = false">閉じる</a>
              <vue-goodshare-facebook
                :page_url="shareUrl()"
                title_social="Facebook"
                class="sns-btn facebook-btn"
              ></vue-goodshare-facebook>
              <vue-goodshare-twitter
                :page_url="shareUrl()"
                title_social="Twitter"
                class="sns-btn twitter-btn"
              ></vue-goodshare-twitter>
              <div
                @click="shareViaLine()"
                class="sns-btn line-btn"
              >LINE</div>
            </div>
          </div>
        </div>
        <pre class="spot-description" v-show="!editing">{{ $store.getters['detail/getDescription'] }}</pre>
        <textarea class="spot-description text" v-model="description" v-show="editing"></textarea>
        <div class="spot-tags" v-show="!editing">
          <span class="spot-tag" v-for="tag in tagObjs" :key="tag.id" @click="searchByTag(tag)">#{{ tag.name }}</span>
        </div>
        <!-- START: Spot tags -->
        <div class="w-100" v-show="editing">
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            :allow-edit-tags="true"
            :avoid-adding-duplicates="true"
            :add-on-key="[13, ':', ';', ',']"
            placeholder="タグ１, タグ 2, タグ３"
            class="tags-input"
            @tags-changed="newTags => tags = newTags"
          >
            <div
              slot="autocomplete-item"
              slot-scope="props"
              class="my-item"
              @click="props.performAdd(props.item)"
            >
              {{ props.item.text }}
            </div>
            <div
              slot="tag-left"
              slot-scope="props"
              class="my-tag-left"
              @click="props.performOpenEdit(props.index)"
            >
            </div>
          </vue-tags-input>
        </div>
        <!-- END: Spot tags -->
        <div class="edit-link-wrap">
          <a href="javascript:void(0)" @click="updateSpotInfos()" v-show="editing">保存</a>
          <a href="javascript:void(0)" @click="showEditForm()" v-show="!editing">【編集】</a>
          <a href="javascript:void(0)" @click="$store.dispatch('menu/setAddForm', true)">【画像を追加】</a>
        </div>

        <div class="comment-btn-wrap">
          <a href="javascript:void(0)" class="comment comment-post" :class="{selected: isComment, unselected: !isComment}" @click="isComment = true">コメント</a>
          <a href="javascript:void(0)" class="comment comment-question" :class="{selected: !isComment, unselected: isComment}" @click="isComment = false">質問する</a>
        </div>

        <ul class="message-area">
          <li v-for="comment in comments" :key="comment.id" :class="{'message-comment' : comment.is_comment, 'message-question' : !comment.is_comment}">
            <p>
              <span class="sender-name">{{ comment.uname || (comment.is_comment ? 'コメントした人' : '質問した人') }}</span>
              <span class="sent-time">{{ moment(comment.created_at).format('YYYY/MM/DD') }}</span>
            </p>
            <div class="message-text-wrap">
              <img v-if="comment.upicture" :src="comment.upicture">
              <img v-if="!comment.upicture && comment.is_comment" src="../../../assets/sample/comment_sample_1.jpeg">
              <img v-if="!comment.upicture && !comment.is_comment" src="../../../assets/sample/comment_sample_2.jpeg">
              <pre class="message-text">{{ comment.content }}</pre>
            </div>
          </li>
        </ul>
      </div>

      <div class="message-edit-form">
        <textarea class="message-area" v-model="message"></textarea>
        <button class="message-send-btn" :disabled="message.trim() === ''" @click="addComment()">送信</button>
      </div>
      <a href="javascript:void(0)" class="btn btn-map" @click="showSpotOnMap()">ここへ行く</a>
    </div>
  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import storage from '../../../utils/vue/LocalStorage'
import Slick from 'vue-slick'
import moment from 'moment'
import VueGoodshare from 'vue-goodshare'
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook'
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter'
import VueGoodshareLine from 'vue-goodshare/src/providers/Line'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'spot-detail',
  props: ['markerCoordinates', 'isDetailShowed'],
  data () {
    return {
      showSns: false,
      editing: false,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        centerMode: true,
        centerPadding: '0%',
        adaptiveHeight: true
      },
      name: '',
      description: '',
      isComment: true,
      message: '',
      comments: [],
      tag: '',
      tagObjs: [],
      tags: [],
      fromSns: false
    }
  },
  mounted: function () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'detail/setId') {
        this.name = this.store.getters['detail/getName']
        this.description = this.store.getters['detail/getDescription']
        setTimeout(() => {
          this.fromSns = this.store.getters['detail/getFromSns']
        }, 0)
        this.loadComments()
        this.loadTags()
      }
    })
  },
  computed: {
    images: function () {
      return this.$store.getters['detail/getImageUrl']
    },
    favorite: function () {
      return this.isFavorite()
    }
  },
  watch: {
    images () {
      this.$nextTick(() => {
        setTimeout(() => {
          let elms = document.getElementsByClassName('slick-list')
          let elm = elms.item(0)
          let div = $('div[data-slick-index="0"]')[0]
          div.offsetHeight > 0 && (elm.setAttribute('style', `height: ${div.offsetHeight}px !important; padding: 0px 0%;`))
          console.log('Set height of elm to ', div.offsetHeight)
        }, 1000)

        this.reSlick()
      })
    },
    isDetailShowed: function (value) {
      if (value) {
        this.getSpotImages()
      } else {
        console.log('on detail page hided', this.fromSns)
        this.fromSns && this.closeModal()
      }
    }
  },
  methods: {
    moment: function () {
      return moment()
    },
    shareUrl: function () {
      return `https:${process.env.API_BASE_URL}share/spot?location=${this.$store.getters['detail/getLat']},${this.$store.getters['detail/getLng']}`
    },
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reSlick () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    resetForm () {
      this.name = this.store.getters['detail/getName']
      this.description = this.store.getters['detail/getDescription']
    },
    addToFavorite () {
      if (!this.isLoggedIn()) {
        this.showModal(this.constant.modal.login, null, true)
        return
      }
      const spotId = this.$store.getters['detail/getId']
      const userId = this.getItem('user_id')
      const params = {user_id: userId, article_id: spotId}
      if (this.isFavorite()) {
        this.postUserApi('favorites/remove', params).then((res) => {
          if (res.result === 'ok') {
            this.removeFavorite()
            this.getMarkerCoordinates()
          }
        })
      } else {
        this.postUserApi('favorites/add', params).then((res) => {
          if (res.result === 'ok') {
            this.addFavorite()
            this.getMarkerCoordinates()
          }
        })
      }
    },
    loadComments () {
      const spotId = this.$store.getters['detail/getId']
      if (!spotId) return
      let params = {article_id: spotId}
      this.getUserApi('comments/index', params).then(data => {
        this.comments = data.data
        this.comments = this.comments.map(c => {
          c.is_comment = c.is_comment === '1'
          return c
        })
      })
    },
    loadTags () {
      const spotId = this.$store.getters['detail/getId']
      if (!spotId) return
      let params = {article_id: spotId}
      this.getUserApi('articles/getTags', params).then(data => {
        this.tagObjs = data.data
        this.tags = this.tagObjs.map(_ => {
          return {text: _.name}
        })
      })
    },
    addComment () {
      const spotId = this.$store.getters['detail/getId']
      const userId = this.getItem('user_id')
      // If user want to answer, he/she have to login
      if (this.isComment && !this.isLoggedIn()) {
        this.showModal(this.constant.modal.login, null, true)
        return
      }
      const body = {
        article_id: spotId,
        user_id: userId,
        content: this.message,
        is_comment: 1 & this.isComment
      }
      this.postUserApi('comments/add', body).then(data => {
        this.message = ''
        this.loadComments()
      })
    },
    getSpotImages () {
      var id = this.store.getters['detail/getId']
      var params = {article_id: id, page: 0}
      this.getUserApi('articles/getImages', params).then((res) => {
        this.store.dispatch('detail/setImageUrl', res.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    showSpotOnMap () {
      console.log('showSpotOnMap....')
      var currentLocation = null
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition((position) => {
          self.openDirectionOnGGMap({lat: position.coords.latitude, lng: position.coords.longitude})
        }, (error) => {
          console.log('======> ', error)
          currentLocation = this.variable.methods.defaultLocation()
          this.openDirectionOnGGMap(currentLocation)
        })
      } else {
        console.log('======> ', currentLocation)
        currentLocation = this.variable.methods.defaultLocation()
        this.openDirectionOnGGMap(currentLocation)
      }
      // this.store.dispatch('zoomLatLng/setLat', this.$store.getters['detail/getLat'])
      // this.store.dispatch('zoomLatLng/setLng', this.$store.getters['detail/getLng'])
      // this.store.dispatch('centerLatLng/setLat', this.$store.getters['detail/getLat'])
      // this.store.dispatch('centerLatLng/setLng', this.$store.getters['detail/getLng'])
      // this.getMarkerCoordinates()
    },
    openDirectionOnGGMap (origin) {
      console.log(`Show directions on Google Map from ${origin.lat},${origin.lng} to ${this.store.getters['detail/getLat']},${this.store.getters['detail/getLng']}`)
      var url = `https://www.google.com/maps/dir/${origin.lat},${origin.lng}/${this.store.getters['detail/getLat']},${this.store.getters['detail/getLng']}`
      window.open(url, '_blank')
      this.closeElement()
    },
    showEditForm () {
      this.editing = true
      this.resetForm()
    },
    updateSpotInfos () {
      let params = new FormData()
      params.append('article_id', this.store.getters['detail/getId'])
      params.append('name', this.name)
      params.append('description', this.description)
      this.tags.forEach(_ => params.append('tags[]', _.text))
      this.postUserApi('articles/update', params).then((res) => {
        const article = res.data
        let {name, description, tags} = article
        this.tagObjs = tags
        this.tags = this.tagObjs.map(_ => {
          return {text: _.name}
        })
        this.store.dispatch('detail/setName', name)
        this.store.dispatch('detail/setDescription', description)
        this.resetForm()
        this.editing = false
      }).catch((error) => {
        console.error(error)
      })
    },
    closeModal () {
      if (this.fromSns) {
        this.showSpotOnMap()
      } else {
        this.closeElement()
      }
    },
    shareViaLine () {
      window.open(`http://line.me/R/msg/text/?GeoMark%0D%0A${this.shareUrl()}`)
    },
    searchByTag (tag) {
      this.store.dispatch('search/setSearchWord', tag.name)
      this.getMarkerCoordinates()
      this.closeElement()
    }
  },
  beforeUpdate () {
    if (this.$refs.slick) {
      this.$refs.slick.destroy()
    }
  },
  updated () {
    this.$nextTick(function () {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions)
      }
    })
  },
  components: {
    Slick,
    VueGoodshare,
    VueGoodshareFacebook,
    VueGoodshareTwitter,
    VueGoodshareLine,
    VueTagsInput
  },
  mixins: [utils, storage]
}
</script>

<style lang="scss" scoped src="../scss/SpotDetailModal.scss"></style>



// WEBPACK FOOTER //
// src/components/modal/vue/SpotDetailModal.vue